type Result = Record<string, any>;
const count = (value: unknown): value is number => Number.isSafeInteger(value) && Number(value) >= 0;
/** Cancellation controls future work; a settled delivery receipt still owns its outputs. */
export function cancelledDeliverySummary(result: unknown): string | undefined {
  if (!result || typeof result !== 'object') return;
  const r = result as Result;
  if (!['complete', 'error'].includes(r.status) || !Array.isArray(r.generated) || r.generated.length > 500) return;
  if (r.generated.some((image: any) => !image || typeof image.id !== 'string' || !image.id || typeof image.imageUrl !== 'string' || !/^https?:\/\//.test(image.imageUrl) || (image.qaPassed !== undefined && typeof image.qaPassed !== 'boolean'))) return;
  if (new Set(r.generated.map((image: any) => image.id)).size !== r.generated.length) return;
  const delivered = r.generated.length;
  const passed = r.generated.filter((image: any) => image.qaPassed === true).length;
  const review = r.generated.filter((image: any) => image.qaPassed === false).length;
  const unknown = delivered - passed - review;
  const quality = `${passed} passed quality review; ${review} need${review === 1 ? 's' : ''} review; ${unknown} ${unknown === 1 ? 'is' : 'are'} not quality-verified.`;
  if (r.deliveryUnverified === true) {
    return `Cancellation was requested. ${delivered} image${delivered === 1 ? ' was' : 's were'} confirmed delivered; the final delivery count is not verified. Already accepted work may still finish. ${quality}`;
  }
  if (!count(r.requestedCount) || !count(r.deliveredCount) || !count(r.failedCount) || r.deliveredCount !== delivered || r.requestedCount < delivered || r.failedCount !== r.requestedCount - delivered) return;
  return `Cancellation was requested. ${delivered} of ${r.requestedCount} requested images delivered. ${r.failedCount ? `${r.failedCount} image${r.failedCount === 1 ? ' was' : 's were'} not delivered.` : 'No images are missing.'} ${quality}`;
}

/** Do not infer zero delivery from cancellation without a counted terminal receipt. */
export function cancelledPlaybookResult(jobId: number, result: unknown) {
  const message = cancelledDeliverySummary(result);
  return {
    ...(message ? result as Result : {}),
    status: message ? (result as Result).status : 'error',
    cancellation: {jobId, requested: true as const},
    message: message ?? 'Remaining work was cancelled. Delivery is not confirmed; images already being created may still finish and appear on this canvas.',
    ...(!message ? {data: {jobId, cancelled: true}} : {}),
  };
}
